/** Rota → gerekli yetki kodu */
export const ROUTE_PERMISSIONS = {
  dashboard: 'page.dashboard',
  financial: 'page.financial',
  fatura: 'page.fatura',
  affiliator: 'page.affiliator',
  'ip-analysis': 'page.ip-analysis',
  'monthly-growth': 'page.monthly-growth',
  'cohort-retention': 'page.cohort-retention',
  'correction-raporu': 'page.correction-raporu',
  'casino-dashboard': 'page.casino-dashboard',
  sportsbook: 'page.sportsbook',
  'free-spin': 'page.free-spin',
  'bonus-raporu': 'page.bonus-raporu',
  'discount-raporu': 'page.discount-raporu',
  'yatirim-cekim-raporu': 'page.yatirim-cekim-raporu',
  kasa: 'page.kasa',
  'cekim-operasyon': 'page.cekim-operasyon',
  'ozel-oran': 'page.ozel-oran',
  'ggr-oyuncu': 'page.ggr-oyuncu',
  'ggr-saglayici': 'page.ggr-saglayici',
  'ggr-oyun': 'page.ggr-oyun',
  'uye-takip': 'page.uye-takip',
  suistimal: 'page.suistimal',
  'fraud-risk': 'page.fraud-risk',
  'musteri-risk': 'page.musteri-risk',
  'top-winners': 'page.top-winners',
  'top-losers': 'page.top-losers',
  'geri-donenler': 'page.geri-donenler',
  'dogum-gunleri': 'page.dogum-gunleri',
  'ftd-report': 'page.ftd-report',
  hesap: 'settings.account',
  telegram: 'settings.telegram',
  'yapay-zeka': 'settings.ai',
  upload: 'page.upload',
  kullanicilar: 'admin.users',
  roller: 'admin.users',
};

/** Excel indirme tanımlı sekmeler (url slug) */
export const EXPORT_PAGE_DEFS = [
  ['dogum-gunleri', 'Doğum Günleri'],
  ['financial', 'Finansal İşlemler'],
  ['affiliator', 'Affiliator Raporu'],
  ['monthly-growth', 'Aylık Büyüme Raporu'],
  ['cohort-retention', 'Cohort / Retention'],
  ['correction-raporu', 'Correction Raporu'],
  ['free-spin', 'Free Spin'],
  ['bonus-raporu', 'Bonus Raporu'],
  ['ggr-oyuncu', 'GGR / Oyuncu'],
  ['ggr-saglayici', 'GGR / Sağlayıcı'],
  ['ggr-oyun', 'GGR / Oyun'],
  ['uye-takip', 'Üye Takip'],
  ['fraud-risk', 'Dolandırıcılık Riski'],
  ['musteri-risk', 'Müşteri Risk Zekâsı'],
  ['top-winners', 'En İyi Yatırımcılar'],
  ['top-losers', 'Artıdaki Üyeler'],
  ['geri-donenler', 'Geri Dönenler'],
  ['ftd-report', 'FTD Raporu'],
  ['yatirim-cekim-raporu', 'Yatırım Çekim Raporu'],
];

export function exportPermissionForSlug(slug) {
  return `export.${slug}`;
}

export function permissionForRoute(pathSlug) {
  return ROUTE_PERMISSIONS[pathSlug] || 'page.dashboard';
}

/** Yetki kodu → kısa etiket */
export const PERMISSION_LABELS = {
  'admin.users': 'Kullanıcı yönetimi',
  'settings.account': 'Hesap ayarları',
  'settings.telegram': 'Telegram',
  'settings.ai': 'Rapor analizi',
  'data.upload': 'Rapor yükleme',
  'data.export': 'Tüm Excel indirme (eski)',
  'reports.read': 'Tüm sekmeler (eski)',
  'pii.phone': 'Telefon görüntüleme',
  'pii.email': 'E-posta görüntüleme',
  'pii.deposits': 'Yatırım verileri',
  'pii.withdrawals': 'Çekim verileri',
  'page.dashboard': 'Dashboard',
  'page.fatura': 'Fatura',
  'page.financial': 'Finansal İşlemler',
  'page.affiliator': 'Affiliator Raporu',
  'page.ip-analysis': 'IP Analizi',
  'page.monthly-growth': 'Aylık Büyüme',
  'page.cohort-retention': 'Cohort / Retention',
  'page.correction-raporu': 'Correction Raporu',
  'page.casino-dashboard': 'Casino Dashboard',
  'page.sportsbook': 'Sportsbook',
  'page.free-spin': 'Free Spin',
  'page.bonus-raporu': 'Bonus Raporu',
  'page.discount-raporu': 'Discount Raporu',
  'page.yatirim-cekim-raporu': 'Yatırım Çekim Raporu',
  'page.kasa': 'Kasa',
  'page.cekim-operasyon': 'Çekim Operasyon',
  'page.ozel-oran': 'Özel Oran',
  'page.ggr-oyuncu': 'GGR / Oyuncu',
  'page.ggr-saglayici': 'GGR / Sağlayıcı',
  'page.ggr-oyun': 'GGR / Oyun',
  'page.uye-takip': 'Üye Takip',
  'page.suistimal': 'Suistimal Zaman Çizelgesi',
  'page.fraud-risk': 'Dolandırıcılık Riski',
  'page.musteri-risk': 'Müşteri Risk Zekâsı',
  'page.top-winners': 'En İyi Yatırımcılar',
  'page.top-losers': 'Artıdaki Üyeler',
  'page.geri-donenler': 'Geri Dönenler',
  'page.dogum-gunleri': 'Doğum Günleri',
  'page.ftd-report': 'FTD Raporu',
  'page.upload': 'Rapor Yükle',
};

EXPORT_PAGE_DEFS.forEach(([slug, label]) => {
  PERMISSION_LABELS[exportPermissionForSlug(slug)] = `Excel indir: ${label}`;
});

const EXPORT_PERMISSION_CODES = EXPORT_PAGE_DEFS.map(([slug]) => exportPermissionForSlug(slug));

export const BASELINE_PERMISSION_CODES = ['settings.account'];

/** Rol düzenleyicide gruplu yetki listesi */
export const PERMISSION_GROUPS = [
  {
    id: 'system',
    label: 'Sistem',
    description: 'Hesap ayarları (şifre, 2FA) tüm kullanıcılarda otomatik açıktır.',
    codes: ['admin.users', 'settings.telegram', 'settings.ai', 'data.upload'],
  },
  {
    id: 'pages-main',
    label: 'Ana Menü',
    codes: ['page.dashboard'],
  },
  {
    id: 'pages-reports',
    label: 'Raporlar',
    codes: [
      'page.fatura',
      'page.financial',
      'page.affiliator',
      'page.ip-analysis',
      'page.monthly-growth',
      'page.cohort-retention',
      'page.correction-raporu',
    ],
  },
  {
    id: 'export-reports',
    label: 'Excel indirme — Raporlar',
    description: 'Sekme görüntüleme yetkisi olmadan export tek başına çalışmaz.',
    codes: [
      'export.financial',
      'export.affiliator',
      'export.monthly-growth',
      'export.cohort-retention',
      'export.correction-raporu',
    ],
  },
  {
    id: 'pages-ggr',
    label: 'Oyun & GGR',
    codes: [
      'page.casino-dashboard',
      'page.sportsbook',
      'page.free-spin',
      'page.discount-raporu',
      'page.yatirim-cekim-raporu',
      'page.kasa',
      'page.cekim-operasyon',
      'page.ozel-oran',
      'page.ggr-oyuncu',
      'page.ggr-saglayici',
      'page.ggr-oyun',
    ],
  },
  {
    id: 'export-ggr',
    label: 'Excel indirme — Oyun & GGR',
    codes: [
      'export.free-spin',
      'export.yatirim-cekim-raporu',
      'export.ggr-oyuncu',
      'export.ggr-saglayici',
      'export.ggr-oyun',
    ],
  },
  {
    id: 'pages-tracking',
    label: 'Kullanıcı Takibi',
    codes: [
      'page.uye-takip',
      'page.dogum-gunleri',
      'page.suistimal',
      'page.fraud-risk',
      'page.musteri-risk',
      'page.top-winners',
      'page.top-losers',
    ],
  },
  {
    id: 'export-tracking',
    label: 'Excel indirme — Kullanıcı Takibi',
    codes: ['export.uye-takip', 'export.fraud-risk', 'export.musteri-risk', 'export.top-winners', 'export.top-losers'],
  },
  {
    id: 'pages-system-tabs',
    label: 'Sistem sekmeleri',
    codes: ['page.geri-donenler', 'page.ftd-report', 'page.upload'],
  },
  {
    id: 'export-system-tabs',
    label: 'Excel indirme — Sistem sekmeleri',
    codes: ['export.geri-donenler', 'export.ftd-report'],
  },
  {
    id: 'privacy-contact',
    label: 'İletişim gizliliği',
    description: 'Telefon ve e-posta alanları maskelenir.',
    codes: ['pii.phone', 'pii.email'],
  },
  {
    id: 'privacy-deposits-withdrawals',
    label: 'Yatırım & çekim gizliliği',
    description: 'Yatırım/çekim tutarları ve adetleri (finansal, yatırımcılar, FTD vb.).',
    codes: ['pii.deposits', 'pii.withdrawals'],
  },
];

export function permissionLabel(code) {
  return PERMISSION_LABELS[code] || code;
}

export function hasPermissionCode(userPermissions, code) {
  if (!code) return true;
  if (BASELINE_PERMISSION_CODES.includes(code)) return true;
  const perms = userPermissions || [];
  if (perms.includes(code)) return true;
  if (code.startsWith('page.') && perms.includes('reports.read')) return true;
  return false;
}

/** Sekme bazlı Excel indirme — eski data.export tüm sekmelere izin verir. */
export function hasExportPermission(userPermissions, slug) {
  const perms = userPermissions || [];
  const code = exportPermissionForSlug(slug);
  if (perms.includes(code)) return true;
  if (perms.includes('data.export')) return true;
  return false;
}

export function allPagePermissionCodes() {
  return Object.values(ROUTE_PERMISSIONS).filter((c) => c.startsWith('page.'));
}

export function allExportPermissionCodes() {
  return EXPORT_PERMISSION_CODES;
}

export function togglePermissionList(list, code) {
  return list.includes(code) ? list.filter((c) => c !== code) : [...list, code];
}

export function selectAllInGroup(list, group) {
  const set = new Set(list);
  group.codes.forEach((c) => set.add(c));
  return [...set];
}

export function clearGroupFromList(list, group) {
  const remove = new Set(group.codes);
  return list.filter((c) => !remove.has(c));
}
